// Colar print no chat do AppCel — peca UNICA pros dois lados.
//
// O `ChatApp` (cliente) e o `ChatAtender` (loja) ja reusam `PlayerAudio` e
// `GravadorVoz` daqui pelo mesmo motivo: regra escrita a mao em dois lugares
// diverge sozinha, e o modo de falhar aqui e' mudo (colar para de funcionar de
// um lado so e ninguem percebe).
//
// ⚠️ **Devolve `File`, nao base64** — e' o que `enviarFoto` ja recebe da camera
// e da galeria nos dois chats, entao colar entra pelo caminho que ja reduz a
// foto pra 1600px antes de subir. Caminho novo de envio nao nasce daqui.
//
// ⚠️ **Texto continua colando normal**: so o item de imagem e' interceptado, e
// so ai o evento e' cancelado. Print copiado junto com texto (acontece no
// Windows) manda a imagem e deixa o texto no campo.

// ⚠️ **O evento de colar NAO alcanca o iPhone** (medido no aparelho dele em
// 17/08/2026): colar imagem num `<textarea>` do Safari do iOS nao entrega
// arquivo nenhum. Quem funciona la e' LER o clipboard sob demanda, dentro de um
// toque — `navigator.clipboard.read()`, que o Safari suporta desde a 13.1 e o
// iOS espelha (dado bruto do MDN, `api/Clipboard.json`). E' o mesmo caminho que
// o Leitor de Voz do ERP ja usa no botao "Colar print".
//
// Sao DUAS pecas de proposito, e nenhuma cobre a outra: o evento pega o Ctrl+V
// do PC e do Android sem tirar a mao do teclado; o botao pega o iPhone, onde o
// evento e' surdo. Matar uma deixa metade dos aparelhos sem colar.
//
// ⚠️ Chamar SEM `await` antes: o Safari exige que a leitura comece dentro do
// gesto, e um `await` no meio gasta a janela — mesmo defeito que o
// compartilhar do [DA-524] levou pra aprender.
// ⚠️ **A promessa pode NUNCA se resolver, e sem o relogio o botao fica mudo.**
// Medido em 17/08/2026: com a permissao de clipboard em `prompt` e ninguem pra
// responder a janela, `read()` nao resolve NEM rejeita — o `catch` nunca roda, a
// folha fecha e a tela nao diz nada. E' o mesmo caso do iPhone quando a pessoa
// dispensa o "Colar" que o Safari mostra. Botao que some sem falar e' beco sem
// saida; o relogio transforma o silencio numa frase.
const ESPERA_CLIPBOARD_MS = 12000;

// ⚠️ **A recusa tem CAUSAS OPOSTAS e a tela contava todas igual** — foi assim que
// o aviso do iPhone dele, em 17/08, nao respondeu nada sobre o proprio defeito.
// `NotAllowedError` na hora = o navegador nao aceitou a leitura (gesto perdido ou
// permissao); espera estourada = a janela "Colar" apareceu e ninguem respondeu;
// `sem-suporte` = o aparelho nao tem a API. Sao consertos diferentes, entao o
// codigo vai NA TELA, entre parenteses, junto do tempo que levou.
//
// ⬜ **Sonda com volta marcada**: sai do texto quando o caso do iPhone estiver
// fechado — ate la ela e' a unica coisa que separa as tres hipoteses, porque o
// aparelho e' dele e eu nao alcanco o console de la.
export class ErroClipboard extends Error {
  constructor(readonly codigo: string) {
    super(codigo);
    this.name = 'ErroClipboard';
  }
}

export async function fotoDoClipboard(): Promise<File | null> {
  if (!navigator.clipboard?.read) throw new ErroClipboard('sem-suporte');
  const comeco = performance.now();
  const segundos = () => ((performance.now() - comeco) / 1000).toFixed(1) + 's';
  let relogio: ReturnType<typeof setTimeout> | undefined;
  const itens = await Promise.race([
    navigator.clipboard.read(),
    new Promise<never>((_, rejeitar) => {
      relogio = setTimeout(() => rejeitar(new ErroClipboard('sem-resposta')), ESPERA_CLIPBOARD_MS);
    }),
  ])
    .catch((e: unknown) => {
      if (e instanceof ErroClipboard) throw new ErroClipboard(`${e.codigo}, ${segundos()}`);
      throw new ErroClipboard(`${(e as Error)?.name || 'erro'}, ${segundos()}`);
    })
    .finally(() => clearTimeout(relogio));
  for (const item of itens) {
    const tipo = item.types.find((t) => t.startsWith('image/'));
    if (tipo) {
      const blob = await item.getType(tipo);
      const ext = tipo.split('/')[1]?.split('+')[0] || 'png';
      return new File([blob], `print.${ext}`, { type: tipo });
    }
  }
  return null;
}

export function fotoDoColar(e: React.ClipboardEvent): File | null {
  const itens = e.clipboardData?.items;
  if (!itens) return null;
  for (const item of Array.from(itens)) {
    if (item.kind === 'file' && item.type.startsWith('image/')) {
      const arquivo = item.getAsFile();
      if (arquivo) {
        e.preventDefault();
        return arquivo;
      }
    }
  }
  return null;
}
